var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTarjetaDeDebito(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 47.34 31.91",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#5d647f;}.cls-2{fill:#ffd100;}.cls-3{fill:#b8bac0;}.cls-4{fill:#8a8895;}.cls-5{fill:#ff4f19;}.cls-6{fill:#ff9500;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Recurso 21otros") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "WEB_VIEW",
    "data-name": "WEB VIEW"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M43.64,0H3.7A3.6,3.6,0,0,0,0,3.47v25a3.6,3.6,0,0,0,3.7,3.47H43.64a3.6,3.6,0,0,0,3.7-3.47v-25A3.6,3.6,0,0,0,43.64,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M16.27,13.87H7.4a1.43,1.43,0,0,1-1.48-1.38V6.94A1.43,1.43,0,0,1,7.4,5.55h8.87a1.43,1.43,0,0,1,1.48,1.39v5.55A1.43,1.43,0,0,1,16.27,13.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M11.09,22.89H7.4A1.43,1.43,0,0,1,5.92,21.5v-.69A1.43,1.43,0,0,1,7.4,19.42h3.69a1.43,1.43,0,0,1,1.48,1.39v.69A1.43,1.43,0,0,1,11.09,22.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M20.71,22.89H17a1.44,1.44,0,0,1-1.48-1.39v-.69A1.44,1.44,0,0,1,17,19.42h3.7a1.43,1.43,0,0,1,1.48,1.39v.69A1.43,1.43,0,0,1,20.71,22.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M30.33,22.89h-3.7a1.43,1.43,0,0,1-1.48-1.39v-.69a1.43,1.43,0,0,1,1.48-1.39h3.7a1.44,1.44,0,0,1,1.48,1.39v.69A1.44,1.44,0,0,1,30.33,22.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M39.94,22.89h-3.7a1.44,1.44,0,0,1-1.48-1.39v-.69a1.44,1.44,0,0,1,1.48-1.39h3.7a1.43,1.43,0,0,1,1.48,1.39v.69A1.43,1.43,0,0,1,39.94,22.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M21.45,27.05H6.66a.69.69,0,1,1,0-1.38H21.45a.69.69,0,1,1,0,1.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M31.07,27.05H24.41a.69.69,0,1,1,0-1.38h6.66a.69.69,0,1,1,0,1.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M34,12.49a4.54,4.54,0,0,1-3.3,1.38,4.31,4.31,0,0,1-4.44-4.16,4.31,4.31,0,0,1,4.44-4.16A4.51,4.51,0,0,1,34,6.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "17.75 10.4 10.36 10.4 10.36 9.02 17.75 9.02 17.75 7.63 10.36 7.63 10.36 5.55 8.88 5.55 8.88 13.87 10.36 13.87 10.36 11.79 17.75 11.79 17.75 10.4"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-2",
    cx: 36.98,
    cy: 9.71,
    rx: 4.44,
    ry: 4.16
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTarjetaDeDebito);
export default __webpack_public_path__ + "static/media/tarjeta-de-debito.1d53fd00006250c7c2ff8ecbf9339674.svg";
export { ForwardRef as ReactComponent };